import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import { cn } from '../../../lib/utils';
import { Accordion } from '../../../components/ui';
import { getTicketOriginalDescription } from '../ticketingOriginalDescription';

/**
 * Collapsible block with the original ticket description (from payload at creation).
 */
export function TicketingOriginalDescriptionFooter({
  payload,
  formKey,
  className,
  defaultOpen = true,
}) {
  const { theme } = useTheme();
  const text = getTicketOriginalDescription(payload, formKey);
  if (!text) return null;

  return (
    <Accordion
      title="Original ticket description"
      defaultOpen={defaultOpen}
      className={cn('rounded-lg', className)}
      contentClassName="pt-0"
    >
      <div
        className={cn(
          'rounded-md border px-3 py-2 text-sm leading-relaxed',
          'border-slate-200/90 dark:border-slate-700/80',
          'bg-slate-50/50 dark:bg-slate-950/30',
          theme.text.primary,
        )}
      >
        <p className="whitespace-pre-wrap break-words m-0">{text}</p>
      </div>
    </Accordion>
  );
}

export default TicketingOriginalDescriptionFooter;
